export default __webpack_public_path__ + "c582e0f510d60610fc55ac91b0603211.svg";